import {
  State,
  AdjustCurrentIndexPayload as Payload,
} from "components/bookShuffle/useBookShuffle/types";

/**
 * Moves the current index either backwards or forwards 1.
 */
export function adjustCurrentIndex(state: State, payload: Payload): State {
  const { adjustment } = payload;
  const currentIndex = state.currentIndex + adjustment;
  const isAnimating = adjustment > 0;
  return {
    ...state,
    currentIndex,
    isAnimating,
  };
}
